import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-eb6725c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "recommend-product",
  "data-nosnippet": ""
};
const _hoisted_2 = {
  key: 0,
  class: "title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-text"
}, "优品推荐", -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  class: "recommend-product__list"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_product_item = _resolveComponent("product-item");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.headerVisible ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loading ? new Array(_ctx.skeletonNum) : _ctx.list, (product, index) => {
    var _product$id;
    return _openBlock(), _createBlock(_component_product_item, {
      key: (_product$id = product === null || product === void 0 ? void 0 : product.id) !== null && _product$id !== void 0 ? _product$id : index,
      keywords: _ctx.keywords,
      item: product,
      loading: _ctx.loading,
      "log-info": {
        alias: _ctx.componentAlias,
        pos: index,
        ..._ctx.logInfo
      }
    }, null, 8, ["keywords", "item", "loading", "log-info"]);
  }), 128))])]);
}